// tslint:disable: completed-docs
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OlaLoanProtectionOptionsComponent } from './components/ola-loan-protection-options/ola-loan-protection-options.component';
import { OlaEligibilityComponent } from './custom-pages/ola-eligibility/ola-eligibility.component';
import { OlaCustomPopupModule } from './custom-modals/ola-custom-modals.module';
import { OlaInterstitialComponent } from './custom-pages/ola-interstitial/ola-interstitial.component';
import { FormsModule } from '@angular/forms';
import { PageSharedModule } from '@workflow/dynamic-render/page/shared/page-shared.module';
import { DynamicRenderSharedModule } from '@workflow/dynamic-render/shared/shared.module';
import { DynamicPipeModule } from '@workflow/pipe/dynamic-pipe.module';
import { UtilitiesService } from '@shared/service/utilities.service';

const customPages = [OlaEligibilityComponent, OlaInterstitialComponent];

const components = [OlaLoanProtectionOptionsComponent, customPages];

@NgModule({
  declarations: [...components],
  exports: [...components, OlaCustomPopupModule],
  imports: [CommonModule, PageSharedModule, DynamicPipeModule, DynamicRenderSharedModule, OlaCustomPopupModule, FormsModule],
  providers: [UtilitiesService]
})
export class OlaModule {}
